import { experimentalStyled } from '@material-ui/core/styles';

const LogoRoot = experimentalStyled('svg')``;

const Logo = (props) => (
  <LogoRoot
    height="52"
    version="1.1"
    viewBox="0 0 52 52"
    width="52"
    {...props}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      style={{
        enableBackground: 'new 0 0 1024 1024',
      }}
      xmlSpace="preserve"
      {...props}
    >
      <path
        style={{
          fill: '#11113c',
        }}
        d="M701.6 0H489.7v209h211.9v209.2h209V0z"
      />
      <path
        d="M702.9 630.6C699.4 732.9 615.1 815 512 815s-187.4-82.1-190.9-184.4h-209C115.6 848.4 293.3 1024 512 1024s396.4-175.6 399.9-393.4h-209z"
        style={{
          fill: '#2d4da0',
        }}
      />
      <path
        style={{
          fill: '#fcb913',
        }}
        d="M112.1 209.1h212.6v212.6H112.1z"
      />
    </svg>
  </LogoRoot>
);

export default Logo;
